import Vue from "vue";
import {
  fetchDiscountList,
  createDiscount,
  createDiscountTrigger,
  createDiscountRule,
  createDiscountRate,
  discountTriggerData,
  deleteDiscountTrigger,
  getDiscountRate,
  deleteDiscountRate,
  deleteDiscountRule,
  updateDiscount,
  updateDiscountTrigger,
  updateDiscountTriggerCondition,
  updateDiscountRule,
  createTriggerCondition,
  getTriggerConditionData,
  deleteTriggerConditionData,
  getReportsTemplateData,
  getTicketSubCategory,
  ruleEntityListApi,
  ruleValueOptionsApi,
  triggerEntityListApi,
  TriggerValueOptionsApi,
  deleteDiscountRuleApi,
  getExternalPromotions,
  fetchPromotionList,
  getDayOfWeek,
  getCodeValuesById
} from "@/http/setup/discount";

export default {
  namespaced: true,
  state: {
    discountTriggers: {},
    CreateViewReportTemplate: {},
    ticketSubcategory: [],
    discountRule: {},
    triggerCondition: [],
    ruleEntityList: [],
    ruleValueOptions: {
      data: {},
      loading: false,
    },
    triggerEntityList: [],
    externalPromoList: [],
    triggerValueOptions: {
      data: {},
      loading: false,
    },
    dayOfWeek: [],
    week: [],
  },
  actions: {
    async getDayOfWeekAction({ commit }) {
      try {
        const res = await getDayOfWeek();
        commit("DAY_OF_WEEK_ACTION", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchDayListById({ commit }, id) {
  try {
    const response = await getCodeValuesById(id); 
    const data = Array.isArray(response.data) ? response.data : [];
    const weekArray = data.map(item => ({
      id: item.id,
      mCodeValue: item.name || item.mCodeValue,
    }));

    commit("SET_WEEK", weekArray);
  } catch (error) {
    console.error("Error fetching day list:", error);
    commit("SET_WEEK", []);
  }
},
    async fetchRuleEntityList({ commit }) {
      try {
        let res = await ruleEntityListApi();
        commit("SET_RULE_ENTITY_LIST", res.data.response);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchRuleValueOptions({ commit }, templatename) {
      try {
        let res = await ruleValueOptionsApi(templatename);
        commit("SET_RULE_VALUE_OPTIONS", {
          data: res.data.response,
          key: templatename,
        });
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchTriggerEntityList({ commit }) {
      try {
        let res = await triggerEntityListApi();
        commit("SET_TRIGGER_ENTITY_LIST", res.data.response);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getExternalPromotionsAction({ commit }) {
      try {
        let res = await getExternalPromotions();
        commit("SET_EXTERNAL_PROMO_LIST", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchTriggerValueOptions({ commit }, templatename) {
      try {
        let res = await TriggerValueOptionsApi(templatename);
        commit("SET_TRIGGER_VALUE_OPTIONS", {
          data: res.data.response,
          key: templatename,
        });
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchDiscountList() {
      try {
        return await fetchDiscountList();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchPromotionListAction(_, id) {
      try {
        return await fetchPromotionList(id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createDiscount(_, data) {
      try {
        return await createDiscount(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateDiscountAction(_, data) {
      try {
        return await updateDiscount(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createDiscountTrigger(_, payload) {
      try {
        return await createDiscountTrigger(payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateDiscountTrigger(_, data) {
      try {
        return await updateDiscountTrigger(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateDiscountTriggerCondition(_, data) {
      try {
        return await updateDiscountTriggerCondition(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createDiscountRule(_, payload) {
      try {
        return await createDiscountRule(payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateDiscountRule(_, payload) {
      try {
        return await updateDiscountRule(payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteDiscountRule(_, id) {
      try {
        return await deleteDiscountRuleApi(id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createDiscountRate(_, payload) {
      try {
        return await createDiscountRate(payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setDiscountTriggerList({ commit }, id) {
      try {
        const response = await discountTriggerData(id);
        commit("DISCOUNT_TRIGGER_LIST", response.data);
        return response;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async deleteDiscountTriggerAction(_, id) {
      try {
        return await deleteDiscountTrigger(id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setDiscountRuleData({ commit }, id) {
      try {
        const response = await getDiscountRate(id);
        commit("SET_DISCOUNT_RULE", response.data);
        return response;
      } catch (error) {
        commit("SET_DISCOUNT_RULE", {});
        throw Error(`Something went wrong`);
      }
    },
    async deleteDiscountRuleAction(_, id) {
      try {
        return await deleteDiscountRule(id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteDiscountRateAction(_, id) {
      try {
        return await deleteDiscountRate(id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createDiscountTriggerCondition(_, data) {
      try {
        return await createTriggerCondition(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setTriggerConditionData({ commit }, id) {
      try {
        const response = await getTriggerConditionData(id);
        commit("SET_TRIGGER_CONDITION", response.data);
        return response;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async deleteTriggerConditionData(_, id) {
      try {
        const response = await deleteTriggerConditionData(id);
        return response;
      } catch (error) {
        throw Error(`Something went wrong`);
      }
    },
    async setReportsTemplateData({ commit }) {
      try {
        const resp = await getReportsTemplateData();
        commit("SET_CREATE_REPORT_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async setTicketSubcategory({ commit }, parameterName) {
      try {
        const response = await getTicketSubCategory(parameterName);
        commit("SET_TICKET_SUBCATEGORY", response.data);
        return response;
      } catch (error) {
        throw error;
      }
    },
  },
  mutations: {
    DAY_OF_WEEK_ACTION(state, payload) {
      state.dayOfWeek = payload;
    },
    SET_WEEK(state, weekArray) {
      state.week = weekArray;
    },
    DISCOUNT_TRIGGER_LIST(state, payload) {
      state.discountTriggers = payload;
    },
    SET_DISCOUNT_RULE(state, payload) {
      state.discountRule = payload;
    },
    SET_EXTERNAL_PROMO_LIST(state, payload) {
      state.externalPromoList = payload;
    },
    SET_TRIGGER_CONDITION(state, payload) {
      state.triggerCondition = payload;
    },
    SET_CREATE_REPORT_LIST(state, payload) {
      state.CreateViewReportTemplate = payload;
    },
    SET_TICKET_SUBCATEGORY(state, payload) {
      state.ticketSubcategory = payload;
    },
    SET_RULE_ENTITY_LIST(state, payload) {
      state.ruleEntityList = payload;
    },
    SET_RULE_VALUE_OPTIONS(state, payload) {
      Vue.set(state.ruleValueOptions.data, payload.key, payload.data);
    },
    SET_TRIGGER_ENTITY_LIST(state, payload) {
      state.triggerEntityList = payload;
    },
    SET_TRIGGER_VALUE_OPTIONS(state, payload) {
      Vue.set(state.triggerValueOptions.data, payload.key, payload.data);
    },
  },
};
